import React, { PureComponent, useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import OemSellerBDP from './MainContent/index';
import BrokerDealerBDP from './MainContent/BrokerDealerBDP';
import BoatDetailsPage from './MainContent/BoatDetailsPage';
import DefaultLayout from '../../layouts/Default';
import ErrorMessage from '../../components/ErrorMessage';
import { withCookies, Cookies } from 'react-cookie';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import get from 'lodash/get';
import * as utils from '../../store/utils';
import * as actions from '../../store/actions';
import * as tridentActions from '../../store/actions/tridentApi';
import {
  generateSearchPath,
  hyphenateUrlComponents
} from '../../utils/urlHelpers/boats';
import { getBoatUrl } from '../../utils/urlHelpers/boat';
import { listingPropTypes } from '../../utils/commonPropTypes';
import { UNAVAILABILITY_REDIRECT_COOKIE } from '../../constants/cookies';
import { runOnce } from '../../utils/runOnceHelper';
import { setCookie } from '../../utils/cookies';
import { isBrokerBDP } from '../../utils/newBDPHelper';
import { PortalConfigContext } from '../../config/portal';

const BDPBrokerDealer = (props) => {
  return (
    <BoatDetailsPage {...props}>
      <BrokerDealerBDP {...props} />
    </BoatDetailsPage>
  );
};

const BoatDetailsComponent = (props) => {
  const { listing } = props;
  const context = useContext(PortalConfigContext);
  const newDesignActive = isBrokerBDP(listing, context);
  return newDesignActive ? (
    <BDPBrokerDealer {...props} />
  ) : (
    <OemSellerBDP {...props} />
  );
};

BoatDetailsComponent.propTypes = {
  listing: listingPropTypes
};

class BoatDetails extends PureComponent {
  constructor(props) {
    super(props);

    const { cookies, statusCode } = this.props;
    if ([301, 302].includes(statusCode)) {
      setCookie(cookies, UNAVAILABILITY_REDIRECT_COOKIE, true);
    }
  }

  renderDefaultLayout() {
    const isOemModel = get(this.props, 'listing.isOemModel', false);
    const brandID = get(this.props, 'listing.oemDetails.brandId');

    const pageType = isOemModel && brandID ? 'BoatDetailsOEM' : 'BoatDetails';
    return (
      <DefaultLayout {...this.props} pageType={pageType} brandID={brandID}>
        {this.props.errors ? (
          <ErrorMessage {...this.props} />
        ) : (
          <BoatDetailsComponent {...this.props} pageType={pageType} />
        )}
      </DefaultLayout>
    );
  }

  render() {
    const { listing, location, statusCode } = this.props;

    if ([301, 302].includes(statusCode)) {
      const searchPathData = { make: hyphenateUrlComponents(listing.make) };
      if (listing.model) {
        searchPathData.model = hyphenateUrlComponents(listing.model);
      }

      return <Redirect to={{ pathname: generateSearchPath(searchPathData) }} />;
    }

    const isNotCanonicalUrl =
      listing && !getBoatUrl(listing).includes(get(location, 'pathname'));
    if (utils.isServer() && isNotCanonicalUrl && this.props.success) {
      let canonicalRedirect = getBoatUrl(listing) + get(location, 'search');
      return <Redirect to={canonicalRedirect} {...this.props} />;
    }

    return this.renderDefaultLayout();
  }
}

const processTridentLoanSpecs = (state) => {
  const teaserRate = get(state.app, 'trident.rates[0].teaserRate');
  const listing = get(state.app, 'data', {});
  const loanAmount = parseFloat(listing.price?.type?.amount?.USD || 0);

  return {
    tridentTeaserRate: parseFloat(teaserRate?.replace(/[%, ]/g, '')),
    tridentLoanAmount: loanAmount,
    tridentTermInMonths: loanAmount >= 50000 ? 240 : 180
  };
};

const mapStateToProps = (state) => {
  const { tridentTeaserRate, tridentLoanAmount, tridentTermInMonths } =
    processTridentLoanSpecs(state);

  return {
    params: get(state.app, 'params', {}),
    listing: get(state.app, 'data', {}),
    sponsored: get(state.app, 'data.sponsored', {}),
    interestingInformation: get(state.app, 'data.interestingInformation', {}),
    isWorking: state.app.isWorking,
    componentWorking: state.app.componentWorking,
    success: state.app.success,
    errors: state.app.errors,
    message: state.app.message,
    user: state.app.user,
    myboats: state.app.myboats,
    premiumPlacement: get(state.app, 'data.premiumPlacementAd', { found: 0 }),
    carouselClickCount: state.app.carouselClickCount,
    navLinks: state.app.navLinks,
    statusCode: state.app.statusCode,
    boatLoansSection: get(state.app, 'trident.boatLoansSection', {
      error: true
    }),
    tridentTeaserRate,
    tridentLoanAmount,
    tridentTermInMonths,
    isLeadSubmitted: get(state.app, 'trident.isLeadSubmitted', false),
    ficoScores: tridentActions.getFicoScores(
      get(state.app, 'trident.rates[0].rates'),
      []
    )
  };
};

BoatDetails.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  errors: PropTypes.bool,
  listing: listingPropTypes,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired,
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string,
    searchUrl: PropTypes.string
  }),
  statusCode: PropTypes.number,
  success: PropTypes.bool,
  boatLoansSection: PropTypes.object,
  tridentTeaserRate: PropTypes.number,
  tridentLoanAmount: PropTypes.number,
  tridentTermInMonths: PropTypes.number,
  abTestContext: PropTypes.shape({
    featureFlags: PropTypes.array
  })
};

// we create a function that will run only once bypassing multiple renders.
const justFirstTime = runOnce();

export default withCookies(
  connect(
    mapStateToProps,
    null
  )(
    frontloadConnect(
      async ({
        dispatch,
        location,
        cookies,
        debug = process.env.REACT_APP_LOCAL_DEBUG
      }) => {
        if (
          utils.isServer() ||
          actions.shouldGetData(location) ||
          (justFirstTime() && debug)
        ) {
          return await Promise.allSettled([
            dispatch(actions.getBoatData(location.pathname, cookies.cookies)),
            dispatch(tridentActions.getBoatLoansFromEditorialAPI()),
            dispatch(tridentActions.getRatesFromTridentAPI())
          ]);
        }
      },
      {
        onUpdate: true,
        onMount: true
      }
    )(BoatDetails)
  )
);
